import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AskNaviChatComponent,
  AskNaviChatStateService,
  ConversationSidebarComponent,
} from '@brighthub/ask-navi-ui';

/**
 * Shell layout for the Ask Navi subapp: conversation sidebar plus main chat panel.
 * Home Go uses `?q=` to seed the first message after conversations load.
 */
@Component({
  selector: 'an-ask-navi-layout',
  standalone: true,
  imports: [CommonModule, ConversationSidebarComponent, AskNaviChatComponent],
  templateUrl: './ask-navi-layout.component.html',
  styleUrl: './ask-navi-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskNaviLayoutComponent implements OnInit {
  private readonly _state = inject(AskNaviChatStateService);
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  ngOnInit(): void {
    void this._boot();
  }

  private async _boot(): Promise<void> {
    await this._state.loadConversations();
    const query = this._route.snapshot.queryParamMap.get('q')?.trim();
    if (!query) {
      return;
    }
    this._state.startNewChat();
    await this._state.sendMessage(query);
    await this._router.navigate([], {
      relativeTo: this._route,
      queryParams: {},
      replaceUrl: true,
    });
  }
}
